__turbopack_context__.v({
  "advisorWidth": "_8dazBa_advisorWidth",
  "avatar": "_8dazBa_avatar",
  "avatarBlue": "_8dazBa_avatarBlue",
  "avatarWhite": "_8dazBa_avatarWhite",
  "profile": "_8dazBa_profile",
  "profileMarginBottom": "_8dazBa_profileMarginBottom",
  "profileName": "_8dazBa_profileName",
  "profileTitle": "_8dazBa_profileTitle",
  "profiles": "_8dazBa_profiles",
  "threeLineEllipse": "_8dazBa_threeLineEllipse",
});
